export default {"src":"/_next/static/media/githubIcon.8dffd7b6.svg","height":16,"width":16};